<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .preview-container {
    display: flex;
    flex-direction: column;
    border-radius: utils.in_rem(8px);
    background: colors.get(interfaceWhite);
    flex: 1 0 0;

    .preview-header {
      @include mixins.body2();
      padding: utils.in_rem(6px) utils.in_rem(12px);
      gap: utils.in_rem(8px);
      border-bottom: 1px solid colors.get(interfaceSwGrey_10);
      display: flex;
      align-items: center;
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import SharedResume from "../../../../elements/SharedResume/SharedResume.svelte";
  import { getShareResumeContext } from "./context.svelte";

  const ctx = getShareResumeContext();
</script>

<div class="preview-container">
  <div class="preview-header">
    <IconScale class="fa-eye" size="xs" />
    <span>Preview</span>
  </div>
  <SharedResume resume={ctx.resume} contactEmail={$userStore.email} />
</div>
